export const TICKET_CATEGORY_OPTIONS = [
  { value: 'request', label: 'Request' },
  { value: 'issue', label: 'Issue' },
  { value: 'incident', label: 'Incident' },
] as const

export const TICKET_PRIORITY_OPTIONS = [
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
] as const

export type TicketCategory = (typeof TICKET_CATEGORY_OPTIONS)[number]['value']
export type TicketPriority = (typeof TICKET_PRIORITY_OPTIONS)[number]['value']

export interface NewTicketPayload {
  category: TicketCategory
  priority: TicketPriority
  service_subcategory: number | null
  title: string
  description: string
  form_data: Record<string, string>
}

export function buildNewTicketPayload({
  category,
  priority,
  serviceSubcategoryId,
  title,
  description,
  answers,
}: {
  category: TicketCategory
  priority: TicketPriority
  serviceSubcategoryId: number | null
  title: string
  description: string
  answers: Record<string, string>
}): NewTicketPayload {
  return {
    category,
    priority,
    service_subcategory: serviceSubcategoryId,
    title,
    description,
    form_data: Object.fromEntries(Object.entries(answers).filter(([, value]) => value !== '')),
  }
}
